import { apiService } from './api';
import { getUserInfo } from '../utils/auth';

export const commentService = {
  getAll: async () => {
    try {
      const response = await apiService.get('/Comment/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch Contacts');
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`/Comment/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch Contact');
    }
  },

  create: async (commentData) => {
    try {
      const userinfo = getUserInfo();
      commentData.UserId = userinfo.user.id;
      const response = await apiService.post('/Comment/create', commentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create Comment');
    }
  },

  update: async (id, commentData) => {
    try {
      const response = await apiService.put(`/Comment/${id}`, commentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update Comment');
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/Comment/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete Comment');
    }
  },
  getCommentsByPostId: async (id) => {
    try {
      const response = await apiService.get(`/Comment/Post/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch Contact');
    }
  },
};

export default commentService;
